/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const FETCH_NODES = 'FETCH_NODES';
export const FETCH_NODES_IF_REQUIRED = 'FETCH_NODES_IF_REQUIRED';
export const REFRESH_NODES = 'REFRESH_NODES';
export const CLEAR_NODES = 'CLEAR_NODES';
export const ADD_NODES = 'ADD_NODES';
export const ADD_NODES_CACHE = 'ADD_NODES_CACHE';
export const ADD_NODE = 'ADD_NODE';
export const ADD_NODE_START = 'ADD_NODE_START';
export const ADD_NODE_ERROR = 'ADD_NODE_ERROR';
export const ADD_NODE_SUCCESS = 'ADD_NODE_SUCCESS';
export const ADD_RESPONSE = 'ADD_RESPONSE';
export const ADD_RESPONSE_START = 'ADD_RESPONSE_START';
export const ADD_RESPONSE_ERROR = 'ADD_RESPONSE_ERROR';
export const ADD_RESPONSE_SUCCESS = 'ADD_RESPONSE_SUCCESS';
export const ADD_SLOT = 'ADD_SLOT';
export const ADD_SLOT_START = 'ADD_SLOT_START';
export const ADD_SLOT_ERROR = 'ADD_SLOT_ERROR';
export const ADD_SLOT_SUCCESS = 'ADD_SLOT_SUCCESS';
export const DELETE_NODE = 'DELETE_NODE';
export const DELETE_NODE_START = 'DELETE_NODE_START';
export const DELETE_NODE_ERROR = 'DELETE_NODE_ERROR';
export const DELETE_NODE_SUCCESS = 'DELETE_NODE_SUCCESS';
export const EXPAND_NODE = 'EXPAND_NODE';
export const EXPAND_PATH = 'EXPAND_PATH';
export const SELECT_NODE = 'SELECT_NODE';
export const SELECT_NODES = 'SELECT_NODES';
export const SELECT_NODES_WITH_ERRORS = 'SELECT_NODES_WITH_ERRORS';
export const UPDATE_NODE = 'UPDATE_NODE';
export const UPDATE_NODE_START = 'UPDATE_NODE_START';
export const UPDATE_NODE_ERROR = 'UPDATE_NODE_ERROR';
export const UPDATE_NODE_SUCCESS = 'UPDATE_NODE_SUCCESS';
export const UPDATE_NODES = 'UPDATE_NODES';
export const UPDATE_SLOT = 'UPDATE_SLOT';
export const UPDATE_SLOT_START = 'UPDATE_SLOT_START';
export const UPDATE_SLOT_ERROR = 'UPDATE_SLOT_ERROR';
export const UPDATE_SLOT_SUCCESS = 'UPDATE_SLOT_SUCCESS';
export const UPDATE_SLOT_AND_HANDLERS = 'UPDATE_SLOT_AND_HANDLERS';
export const UPDATE_SLOT_AND_HANDLERS_SUCCESS =
  'UPDATE_SLOT_AND_HANDLERS_SUCCESS';
export const UPDATE_SLOT_AND_HANDLERS_ERROR = 'UPDATE_SLOT_AND_HANDLERS_ERROR';
export const UPDATE_HANDLERS = 'UPDATE_HANDLERS';
export const UPDATE_HANDLERS_START = 'UPDATE_HANDLERS_START';
export const UPDATE_HANDLERS_ERROR = 'UPDATE_HANDLERS_ERROR';
export const UPDATE_HANDLERS_SUCCESS = 'UPDATE_HANDLERS_SUCCESS';
export const MOVE_SUBNODE = 'MOVE_SUBNODE';
export const MOVE_SUBNODE_START = 'MOVE_SUBNODE_START';
export const MOVE_SUBNODE_ERROR = 'MOVE_SUBNODE_ERROR';
export const MOVE_SUBNODE_SUCCESS = 'MOVE_SUBNODE_SUCCESS';
export const ENABLE_SLOTS = 'ENABLE_SLOTS';
export const ENABLE_SLOTS_START = 'ENABLE_SLOTS_START';
export const ENABLE_SLOTS_SUCCESS = 'ENABLE_SLOTS_SUCCESS';
export const ENABLE_MCR = 'ENABLE_MCR';
export const ENABLE_MCR_START = 'ENABLE_MCR_START';
export const ENABLE_MCR_ERROR = 'ENABLE_MCR_ERROR';
export const ENABLE_MCR_SUCCESS = 'ENABLE_MCR_SUCCESS';
export const ENABLE_CALLOUT = 'ENABLE_CALLOUT';
export const ENABLE_CALLOUT_START = 'ENABLE_CALLOUT_START';
export const ENABLE_CALLOUT_ERROR = 'ENABLE_CALLOUT_ERROR';
export const ENABLE_CALLOUT_SUCCESS = 'ENABLE_CALLOUT_SUCCESS';
export const SET_NODE_HASH = 'SET_NODE_HASH';
export const MOVE_NODE = 'MOVE_NODE';
export const MOVE_NODE_START = 'MOVE_NODE_START';
export const MOVE_NODE_ERROR = 'MOVE_NODE_ERROR';
export const MOVE_NODE_SUCCESS = 'MOVE_NODE_SUCCESS';
export const DUPLICATE_NODE = 'DUPLICATE_NODE';
export const DUPLICATE_NODE_START = 'DUPLICATE_NODE_START';
export const DUPLICATE_NODE_ERROR = 'DUPLICATE_NODE_ERROR';
export const DUPLICATE_NODE_SUCCESS = 'DUPLICATE_NODE_SUCCESS';
export const UPDATE_JUMP_TO = 'UPDATE_JUMP_TO';
export const UPDATE_JUMP_TO_START = 'UPDATE_JUMP_TO_START';
export const UPDATE_JUMP_TO_SUCCESS = 'UPDATE_JUMP_TO_SUCCESS';
export const UPDATE_JUMP_TO_ERROR = 'UPDATE_JUMP_TO_ERROR';
